import styled from 'styled-components';

export const FieldSet = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`;
